type Props = {};

const NotFoundPage = (props: Props) => {
  return <>Page Not Found</>;
};

export default NotFoundPage;
